import type {
  GetAppointmentVCPDetailsPayload,
  GetAppointmentVCPDetailsResult,
} from '@shared/services/appointment/getLists/types/getAppointmentVCPDetails.type';
import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_APPOINTMENTS_VCP_DETAILS_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

export const TAG_VCP_DETAILS = 'getAppointmentVCPDetails';

export const getAppointmentVCPDetails = <T extends BuilderType>(builder: T) =>
  builder.query<GetAppointmentVCPDetailsResult, GetAppointmentVCPDetailsPayload>({
    providesTags: [TAG_VCP_DETAILS],
    query: (params) => ({
      data: params,
      method: 'POST',
      url: GET_APPOINTMENTS_VCP_DETAILS_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetAppointmentVCPDetailsResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
